<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <fieldset class="tw-h-full">
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>

          <div class="row">
            <!-- title -->
            <div class="md:tw-w-1/3">
              <form-field
                [(value)]="model.title"
                class="tw-w-full"
                [control]="form?.get('title')"
                label="common.title"
                [maxLength]="250"
              >
              </form-field>
            </div>

            <!--url type-->
            <div class="md:tw-w-1/3">
              <enum-select-search
                class="tw-w-full"
                enumName="UrlType"
                [label]="fields + 'urlType'"
                [control]="form?.get('urlType')"
                [(value)]="model.urlType"
                (valueChange)="onChangeUrlType($event)"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- link field type -->
            <!-- *ngIf="isShowIdOrUrlSelector" -->
            <div class="md:tw-w-1/3">
              <custom-select-search
                label="common.type"
                [items]="
                  $any([
                    { value: 'mainUrl', name: fields + 'mainUrl' | translate },
                    { value: 'socialMediaId', name: 'common.id' | translate }
                  ])
                "
                [control]="form?.get('linkType')"
                optionTitle="name"
                optionValue="value"
                [removable]="false"
                [(value)]="linkFieldType"
                [isDisabled]="!isShowIdOrUrlSelector"
                (valueChange)="onChangeLinkFieldType()"
              >
              </custom-select-search>
            </div>

            <!-- social Network Id -->
            <div
              class="xl:tw-w-2/3"
              *ngIf="
                !isShowMap() &&
                isShowIdOrUrlSelector &&
                linkFieldType == 'socialMediaId'
              "
            >
              <div class="tw-flex tw-w-full">
                <form-field
                  class="tw-w-full"
                  (valueChange)="socialMediaId = $event"
                  [control]="form?.get('socialMediaId')"
                  [label]="'common.id' | translate"
                >
                  <div suffix-content class="tw-bg-white dark:tw-bg-dark-500">
                    <i [urlTypeIcon]="model.urlType"></i>
                  </div>
                </form-field>
              </div>
            </div>

            <!-- Main url -->
            <div
              class="xl:tw-w-2/3"
              *ngIf="
                !isShowMap() &&
                (!isShowIdOrUrlSelector || linkFieldType == 'mainUrl')
              "
            >
              <div class="tw-flex tw-w-full">
                <form-field
                  class="tw-w-full"
                  [(value)]="model.mainUrl"
                  [control]="form?.get('mainUrl')"
                  [label]="fields + 'mainUrl'"
                >
                  <div suffix-content class="tw-bg-white dark:tw-bg-dark-500">
                    <i [urlTypeIcon]="model.urlType"></i>
                  </div>
                </form-field>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="isShowMap()">
            <div class="row tw-mb-3">
              <!-- state -->
              <div class="md:tw-w-1/2">
                <zones-select-search
                  #selStates
                  class="tw-w-full"
                  label="common.state"
                  [control]="form?.get('stateControl')"
                  [id]="1"
                  [value]="stateId"
                  (valueChange)="stateId = $event; cityId = -1"
                >
                </zones-select-search>
              </div>
              <!-- end state -->
              <!-- city -->
              <div class="md:tw-w-1/2">
                <zones-select-search
                  #citySelectSearch
                  class="tw-w-full"
                  label="common.city"
                  [control]="form?.get('cityControl')"
                  [id]="stateId"
                  [value]="cityId"
                  (valueChange)="onCityChange($event)"
                >
                </zones-select-search>
              </div>
              <!-- end city -->
            </div>

            <div class="app-page-content">
              <short-links-map-control
                #Map
                [Theme]="appStateService.currentThemeMode()"
                [ShowSaveButton]="false"
                (OnSave)="onMapSaveButtonClicked($event)"
              >
              </short-links-map-control>
            </div>
          </div>
        </fieldset>
      </div>
      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
